import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import LogoUploader from "./LogoUploader";
import LoginDropdown from "./LoginDropdown";

export default function MinimalHeader({
  content,
  onContentChange,
  isSelected,
  defaultLogo,
}: SectionContentProps) {
  const primaryColor = content.colorPalette?.primary || "#3B82F6";
  const secondaryColor = content.colorPalette?.secondary || "#4F46E5";
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const padding = content.padding || "normal";
  const getPaddingClass = () => {
    if (padding === "compact") return "py-2";
    if (padding === "spacious") return "py-8";
    return "py-4";
  };

  const handleLogoChange = (newLogoUrl: string) => {
    if (onContentChange) {
      onContentChange({ ...content, logo: newLogoUrl });
    }
  };

  return (
    <div
      className={`w-full transition-all ${isSelected ? "ring-2 ring-blue-500 relative z-20 shadow-md" : "border-b border-gray-100"}`}
      style={{
        fontFamily,
        backgroundColor: content.backgroundColor || "#ffffff",
      }}
    >
      <div
        className={`max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between ${getPaddingClass()}`}
      >
        {/* Left Side: Logo */}
        <div className="flex-shrink-0">
          <LogoUploader
            currentLogo={content.logo}
            defaultLogo={defaultLogo}
            onLogoChange={handleLogoChange}
            heightClass="h-10"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            companyName={content.companyName || "INSTACKS"}
            isEditing={!!onContentChange}
          />
        </div>

        {/* Right Side: Login Only */}
        <div>
          <LoginDropdown variant="text" primaryColor={primaryColor} />
        </div>
      </div>
    </div>
  );
}
